import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
    Combo2Service,
    ExcelService,
    ReportService
} from "../../../services/index";
declare var google;

@Component({
  selector: "stock-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./DeliveryReport.html",
})
export class SalesInvoiceAgent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;

  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  gridOptions: any;
  data: any;
  finyearCtrl: FormControl = new FormControl();
  brandList = [];
  styleList = [];
  typeList = [];
  finyearList = [];
  viewTypeList = ["GRID", "TILE"];
  groupbyList = [
    "DESIGN NO",
    "DESIGN COLOR",
    "AGENT",
    "PARTY",
    "SEASON",
    "INVOICE",
    "COLOR",
    "BRAND",
    "STYLE",
    "TYPE",
  ];
  designtypeList = ["CORE", "NEW"];
  actionList = ["YES", "NO"];
  tileViewGroup = ["DESIGN NO", "DESIGN COLOR"];
  salesTypeList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  colorList = [];
  qualityList = [];
  seasonfinList = [];
  seasonList = [];
  agentName = "";
  partylist: any;
  agentlist = [];
  designlist = [];
  newDesignList = [];
  coreDesignList = [];
  listSelected = [];
  newlistSelected = [];
  partyAgentList: any;
  exceldata: any;
  // partyagentList:any;
  fitList = [];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  viewType = "GRID";
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "agent",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Delivery Report",
    columns: [],
    rows: [],
    summaryrow: {},
  };
  user: any;
  designData: any;
  agentVisible: boolean = false;
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("brand") brand;
  @ViewChild("style") style;
  @ViewChild("type") type;
  @ViewChild("fit") fit;
  @ViewChild("color") color;
  @ViewChild("quality") quality;
  @ViewChild("finyear") finyear;
  @ViewChild("designno") designno;
  @ViewChild("agent") agent;
  seasonCtrl: FormControl = new FormControl();

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    name: "",
    //company_id: 0
  };

  flag: boolean = false;
  clear: boolean = false;

  filter: any = {
    groupby: "BRAND",
    sales_type: [],
    design_type: "",
    sizecols: "YES",
    season_id: "3",
    finyear: "3",
    fin_id: "3",
    viewtype: "GRID",
    design: [],
    new_design_no: [],
    brand: [],
    style: [],
    type: [],
    fit: [],
    quality: [],
    color: [],
    saleArray: [],
    coreArray: [],
  };

  @Input() set params(val: any[]) {
    if (val["chkData"] == true) {
      this.filter["groupby"] = "PARTY DESIGN";
      this.flag = true;
      if (val["data"].design_type == "NEW") {
        this.OnSelectnewdesign(val["data"].design_no);
      } else {
        this.OnSelectnewdesign(val["data"].design_no);
      }
      this.filter["shade"] = val["data"].code;
      this.filter.season_id = val["data"].season_id;
      this.filter.fin_id = val["data"].fin_id;
      val["chkData"] = false;
    } else {
      this.filter = {
        groupby: "BRAND",
        sales_type: [],
        design_type: "",
        sizecols: "YES",
        season_id: "3",
        finyear: "3",
        fin_id: "3",
        viewtype: "GRID",
        design: [],
        new_design_no: [],
        brand: [],
        style: [],
        type: [],
        fit: [],
        quality: [],
        color: [],
        saleArray: [],
        coreArray: [],
      };
    }
  }

  constructor(
    public store: Store<fromRootStore.State>,
    private reportService: ReportService,
    public toasterService: ToasterService,
    private combo: Combo2Service,
    public datePipe: DatePipe,
    private excelService: ExcelService
  ) {}

  ngOnInit(): void {
    this.partyCombo();
    this.brandCombo();
    this.styleCombo();
    this.fitCombo();
    this.qualityCombo();
    this.colorCombo();
    this.typeCombo();
    this.newDesignCombo();
    this.coreDesignCombo();
    this.finyearCombo();
    this.seasonCombo();
    this.agentCombo();
    this.designList();

    this.columns = [];
    this.gridOptions = {
      columns: this.columns,
      maxHeight: window.innerHeight - 300 + "px",
      loading: true,
      data: [],
    };

    this.designData = {
      cols: [],
      data: [],
      groupby: "DESIGN NO",
    };

    this.toggleCol = Object.assign({}, this.columns);
    //  this.pageCallback({ offset: 0 });
    this.checkuser();
  }

  checkuser() {
    let that = this;

    if (this.user.params && !this.user.params.agent_id) {
      that.agentVisible = true;
    }

    // this.filter['agent_id'] = this.user.params.agent_id;
  }
  onSelectParty($event) {
    let party_id = $event.item.party_id;
    this.filter.party_id = party_id;
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getAgentYearlyReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  brandCombo() {
    let that = this;
    this.combo.brandCombo().then((res: any) => {
      that.brandList = res.data;
    });
  }
  qualityCombo() {
    let that = this;
    this.combo.qualityCombo().then((res: any) => {
      that.qualityList = res.data;
    });
  }
  typeCombo() {
    let that = this;
    this.combo.typeCombo().then((res: any) => {
      that.typeList = res.data;
    });
  }
  colorCombo() {
    let that = this;
    this.combo.colorCombo().then((res: any) => {
      that.colorList = res.data;
    });
  }
  fitCombo() {
    let that = this;
    this.combo.fitCombo().then((res: any) => {
      that.fitList = res.data;
    });
  }
  styleCombo() {
    let that = this;
    this.combo.styleCombo().then((res: any) => {
      that.styleList = res.data;
    });
  }
  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      if (that.flag == false) {
        that.finyearCtrl.setValue(res.data[0].fin_id);
        that.onSelectFinyear(res.data[0].fin_id);
      } else {
        that.finyearCtrl.setValue(that.filter.fin_id);
      }
    });
  }
  seasonCombo() {
    let that = this;
    this.combo.seasonCombo().then((res: any) => {
      that.seasonList = res.data;
      if (that.flag == false) {
        that.seasonCtrl.setValue(res.data[0].season_id);
        that.getAgentYearlyReport();
      } else {
        that.seasonCtrl.setValue(that.filter.season_id);
        that.getAgentYearlyReport();
      }
    });
  }
  partyCombo() {
    let that = this;
    this.combo.partyCombo().then((res: any) => {
      that.partylist = res.data;
    });
  }
  agentCombo() {
    let that = this;
    this.combo.agentCombo().then((res: any) => {
      that.agentlist = res.data;
      setTimeout(function () {
        that.displayAgent("agent", that.user.params.agent_id);
      }, 200);
    });
  }
  designList() {
    let that = this;
    this.combo.designCombo().then((res: any) => {
      that.designlist = res.data;
    });
  }

  newDesignCombo() {
    let that = this;
    this.combo.newDesignCombo().then((res: any) => {
      that.newDesignList = res;
    });
  }
  coreDesignCombo() {
    let that = this;
    this.combo.coreDesignCombo().then((res: any) => {
      that.coreDesignList = res;
    });
  }

  onClickCheck(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["brand"] = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckstyle(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["style"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickChecktype(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["type"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckfit(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["fit"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckquality(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["quality"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }
  onClickCheckcolor(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["color"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  OnSelectdesignno($event) {
    //
    this.listSelected.push($event.item.design_no);
    this.filter["design"] = this.listSelected;
    this.filter["design_no"] = "";
  }
  onClickAgent(id) {
    let partyagentList = _.filter(this.partylist, { agent_id: id });
    this.partyAgentList = partyagentList;
  }
  onClickFinyear(id) {
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
  }
  onClickSale(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["sales_type"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
    /*if(selected.length == 1){
              this.filter.stocktype = selected[0];
          }
          else{
              this.filter.stocktype = '';
          }*/
  }
  onClickCore(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter["design_type"] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "applyFilter") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      this.applyFilter();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getAgentYearlyReport();
  }

  onbackbutton() {
    this.filter.groupby = "DESIGN NO";
    this.listSelected = [];
    this.newlistSelected = [];
    this.filter["corelist"] = [];
    this.filter["design"] = this.listSelected;
    this.filter.new_design_no = this.newlistSelected;
    this.getAgentYearlyReport();
  }
  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getAgentYearlyReport();
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }
  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id + "" });
      if (!fitem) {
      }

      return fitem["finyear"];
    }
    return "";
  }
  displayAgent(comboType: string, id: number) {
    let list: any = [];
    let agent_id = id + "";
    let that = this;
    if (comboType == "agent") {
      list = this.agentlist;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { agent_id: agent_id });
      this.agentName = fitem["agent_name"];
      return fitem["agent_name"];
    }
    return "";
  }

  addDateParam(field, filter) {
    if (filter[field] && filter[field] !== null) {
      filter[field] = this.datePipe.transform(filter[field], "yyyy-MM-dd");
    } else {
      filter[field] = "";
    }
  }

  getAgentYearlyReport(): void {
    if (this.filter.party_name == "") {
      this.filter["party_id"] = "";
    }
    let filter = Object.assign({}, this.filter);
    this.addDateParam("inv_from_date", filter);
    this.addDateParam("inv_to_date", filter);
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };

    this.isLoadMask = this.reportService
      .getInvoiceReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        if (that.filter.viewtype == "TILE") {
          that.viewType = "TILE";
        } else {
          that.viewType = "GRID";
        }

        that.designData = {
          cols: res.cols,
          data: res.data,
          name: "Delivery",
          groupby: that.filter.groupby,
        };

        that.exceldata = that.getData(res.columns, res.data);
        that.printConfig = {
          title: "Delivery report",
          columns: that.gridOptions.columns,
          rows: that.gridOptions.data,
          summary: that.gridOptions.summaryrow,
        };
      });
  }

  onChangePhoto(status) {
    if (status == true) {
      this.filter.sizecols = "";
    }
  }
  OnSelectcoredesignno($event) {
    //
    this.listSelected.push($event.item.design_no);
    this.filter["design"] = this.listSelected;
    this.filter["design_no"] = "";
  }

  OnSelectnewdesignno($event) {
    //
    this.newlistSelected.push($event.item.design_no);
    this.filter["new_design_no"] = this.newlistSelected;
    this.filter["newdesignno"] = "";
  }

  OnSelectnewdesign(value) {
    this.filter.newdesignno = "";
    this.newlistSelected.push(value);
    this.filter["corelist"] = this.newlistSelected;
    this.filter["new_design_no"] = this.newlistSelected;
    this.filter["newdesignno"] = "";
  }

  OnSelectcoredesign(value) {
    this.filter.design_no = "";
    this.listSelected.push(value);
    this.filter["corelist"] = this.listSelected;
    this.filter["design"] = this.listSelected;
    this.filter["design_no"] = "";
  }

  onCellClick(event, groupby) {
    if (this.filter.groupby == "DESIGN NO") {
      this.filter.groupby = "DESIGN COLOR";
      if (event.row.design_type == "NEW") {
        this.OnSelectnewdesign(event.row.design_no);
      } else {
        this.OnSelectcoredesign(event.row.design_no);
      }

      this.getAgentYearlyReport();
    } else if (this.filter.groupby == "DESIGN COLOR") {
      this.onClickColor(event);
    }
  }

  onClickColor(event) {
    let tabObj = {};
    this.clear = true;
    let chkData = this.clear;
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "DELIVERY_REPORTS",
        title: "DELIVERY REPORT",
        tabParent: "REPORTS",
        data: event.row,
        chkData: chkData,
        name: "SalesInvoiceAgent",
      },
    };

    this.tabUpdateEvent.emit(tabObj);
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  clearFilter(): void {
    this.filter["corelist"] = this.filter.design.concat(
      this.filter.new_design_no
    );

    if (this.filter.coreArray.length == 1) {
      this.filter.design_type = this.filter.coreArray[0];
    } else {
      this.filter.design_type = "";
    }

    this.viewType = "GRID";

    this.getAgentYearlyReport();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filter["corelist"] = this.filter.design.concat(
      this.filter.new_design_no
    );

    if (this.filter.coreArray.length == 1) {
      this.filter.design_type = this.filter.coreArray[0];
    } else {
      this.filter.design_type = "";
    }
    this.filterPanel.close();
    this.viewType = "GRID";

    this.getAgentYearlyReport();
  }

  onSelectFinyear(id) {
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
    this.filter["inv_from_date"] = "";
    this.filter["inv_to_date"] = "";
  }

  onSelectInvDate() {
    this.filter["fin_id"] = 0;
  }

  setData(data) {
    this.data = Object.assign({}, data);
  }

  onSelectAgent(id) {
    let partyAgentList = _.filter(this.partylist, { agent_id: id });
    this.partyAgentList = partyAgentList;
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onRowSelected($event) {
    let data = Object.assign($event.selected[0]);
    data["finyear"] = this.filter["fin_id"];
    const tabObj = {
      action: "NewTab",
      params: {
        tabParent: "REPORTS",
        tabName: "PartySalesOrderReport",
        type: "order",
        mode: "View",
        data: data,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  refreshData() {}

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/DeliveryReport/DeliveryReport.ts